export default {
  "content": "<path d=\"M10.988 1.891c.372-.89 1.652-.89 2.024 0l.034.092 2.15 6.617h6.958c1.065 0 1.508 1.364.647 1.99l-5.63 4.09 2.15 6.618c.329 1.013-.83 1.855-1.692 1.23l-5.63-4.09-5.628 4.09c-.862.625-2.021-.217-1.692-1.23l2.149-6.618-5.629-4.09c-.861-.626-.418-1.989.647-1.99h6.958l2.15-6.617.034-.092z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};